export const buildDoughnutChartOptionsProp = (currentInvestmentPercentage) => {
  return {
    mainText: `${currentInvestmentPercentage}%`,
    mainTextFontSize: 32,
    mainTextX: 2,
    mainTextY: 2.15,
    subText: 'savings',
    subTextFontSize: 24,
    subTextX: 2,
    subTextY: 1.8,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const value = tooltipItem.formattedValue
            return value + '%'
          }
        }
      }
    },
  }
}

export const buildRadarChartOptionsProp = () => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 40,
        right: 80,
        bottom: 40,
        left: 80
      }
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const value = tooltipItem.formattedValue
            return value + '%'
          }
        }
      }
    },
    scales: {
      r: {
        pointLabels: {
          font: {
            size: 14
          },
          padding: 20
        },
        ticks: {
          display: false
        },
      }
    }
  }
}
